import React from 'react'
import { Grid, withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import { last } from 'lodash'
import CancelButton from './CancelButton'
import NextButton from './NextButton'
// import Stepper from './Stepper'

const TopButtons = ({ classes }) => (
  <Grid container justify="space-between" className={classes.buttonsStyle}>
    <Grid item>
      <CancelButton />
    </Grid>
    {/* <Grid item><Stepper /></Grid> */}
    <Grid item>
      <NextButton />
    </Grid>
  </Grid>
)

const styles = (theme) => ({
  buttonsStyle: {
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
      left: 0,
      top: 56,
    },
    width: 'calc(100% - 80px)',
    position: 'fixed',
    left: '80px',
    // bottom: '0px',
    top: 64,
    padding: '12px',
    background: 'white',
    boxShadow: '0px 5px 5px #00000040',
    zIndex: 1,
  },
})

export default connect(
  (state) => ({ cardSelected: last(state.email.cardSelected) }),
  null,
)(withStyles(styles)(TopButtons))
